import { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { AdminLoginForm } from "./AdminLoginForm";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("Info@ncpmechanical.co.uk");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => { if (user) navigate("/admin", { replace: true }); }, [user, navigate]);

  const handleLogin = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (reason) {
      setError(reason.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = `${window.location.origin}/auth/callback`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return <main className="admin-login-page" data-testid="admin-login-page">
    <section className="admin-login-brand">
      <Link to="/" className="admin-back-link" data-testid="admin-back-to-site-link"><ArrowLeft /> Back to website</Link>
      <img src="/ncp-mechanical-logo.png" alt="NCP Mechanical Ltd" data-testid="admin-login-logo" />
      <div><span>CONTENT CONTROL</span><h1 data-testid="admin-login-heading">Manage the work<br />behind the <em>work.</em></h1><p data-testid="admin-login-copy">Projects, clients, services and company content—secured in one focused workspace.</p></div>
    </section>
    <section className="admin-login-panel">
      <AdminLoginForm email={email} error={error} handleGoogle={handleGoogle} handleLogin={handleLogin} password={password} setEmail={setEmail} setPassword={setPassword} submitting={submitting} />
    </section>
  </main>;
}